import systemLoaderAnimation from "@shared/system-loader-animation-v0.3.0";
import { forwardRef, memo, useImperativeHandle } from "react";
import { ErrorBoundary } from "react-error-boundary";
import type { Props } from "../node/definition";

function FallbackComponent({ error }: { error: Error }) {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        padding: 64,
      }}
    >
      <h2 style={{ color: "red" }}>Системная ошибка!</h2>
      <h3>{error.message}</h3>
      <img
        src="error.jpg"
        alt="Error illustration"
        style={{
          display: "block",
          marginLeft: "auto",
          marginRight: "auto",
          marginTop: 64,
          width: "50%",
        }}
      />
    </div>
  );
}
// memo для того, чтобы не реагировать на изменяющиеся логин/пароль при печати.
export default memo(
  forwardRef((p: Props, ref) => {
    // Завершим анимацию.
    systemLoaderAnimation.stop();
    // Изменим реактивное состояние инициализации приложения.
    R.states.init.value = "initialized";

    // Примем внешние сигналы.
    useImperativeHandle(
      ref,
      () => ({
        async signIn() {
          // Авторизуем пользователя, переключив флаг, чтобы авторизация произошла у лидера по подписке.
          await R.db.states.auth.set("username", () => p.username);
          await R.db.states.auth.set("password", () => p.password);
          await R.db.states.auth.set("signIn", () => true);
        },
        async refreshData() {
					if (R.localData?.refreshData) {
            await R.localData.refreshData();
          } else {
            console.warn("R.localData.refreshData is not available");
          }
				},
        async hardRefreshData() {
					if (R.localData?.refreshData) {
            R.localData.localDataReplicationEngine.replicationStates.lastSuccessSync = 0
            await R.localData.refreshData();
          } else {
            console.warn("R.localData.refreshData is not available");
          }
				},
      }),
      [p],
    );

    return (
      <ErrorBoundary FallbackComponent={FallbackComponent}>
        <div style={{ width: "100%", height: "100%" }}>{p.children}</div>
      </ErrorBoundary>
    );
  }),
);
